import ApiInstance from 'src/helpers/apiInstance';
import { defaultApiVersionPath } from 'src/settings';
import { CONTRACT_ACTIONS } from '../constants';
import type { ContractActionKey } from '../constants';
import type { IEndpointAction } from '../sharedTypes';

export const findAction = (actions: IEndpointAction[] | undefined, key: ContractActionKey): IEndpointAction | null =>
  (Array.isArray(actions) ? actions : []).find(action => action.key === key) ?? null;

export const hasAction = (actions: IEndpointAction[] | undefined, key: ContractActionKey): boolean =>
  findAction(actions, key) !== null;

// An invite-list row says which world it is in only through its actions: the engine-bound presenter offers
// `show`, the legacy one only `update` and `resend`. The active list carries `engine_bound` instead.
export const isEngineBoundRow = (row: { actions?: IEndpointAction[] } | null | undefined): boolean =>
  hasAction(row?.actions, CONTRACT_ACTIONS.SHOW);

export const renderableActions = (actions: IEndpointAction[] | undefined): IEndpointAction[] =>
  (Array.isArray(actions) ? actions : []).filter(action => action.key !== CONTRACT_ACTIONS.UNROUTED_DESTROY);

// Action urls arrive as full paths ("/api/v1/agency_contracts/:id"). getRequestUrl prepends host and
// version path: a leading slash gives "host//…", a bare "api/v1/…" doubles the version path.
export const toPathTemplate = (url: string): string =>
  url.startsWith(`${defaultApiVersionPath}/`) ? url.slice(defaultApiVersionPath.length + 1) : url.replace(/^\/+/, '');

const METHODS = {
  get: (instance: ApiInstance) => instance.get,
  post: (instance: ApiInstance) => instance.post,
  put: (instance: ApiInstance) => instance.put,
  delete: (instance: ApiInstance) => instance.delete,
} as const;

export const requestForAction = (action: IEndpointAction | null | undefined) => {
  const method = action?.method?.toLowerCase() as keyof typeof METHODS | undefined;

  if (!action?.url || !method || !(method in METHODS)) return null;

  return METHODS[method](new ApiInstance(toPathTemplate(action.url)));
};
